import { RentPayment } from "./RentPayment";

export interface CreateTenant {
    apartmentId: string;
    firstName: string;
    lastName: string;
    documentType: DocumentType;
    documentNumber: string;
    email?: string;
    primaryPhone: string;
    secondaryPhone?: string;
    profession?: string;
    employer?: string;
    monthlyIncome?: number | null;
    moveInDate: Date | string;
}

export enum DocumentType {
    CEDULA_NACIONAL = 1,
    DIMEX = 2,
    PASAPORTE = 3
}

export interface Tenant {
    id: string;
    fullName: string;
    documentType?: string;
    documentNumber: string;
    email?: string;
    primaryPhone: string;
    secondaryPhone?: string;
    emergencyContactName?: string;
    emergencyContactPhone?: string;
    profession?: string;
    employer?: string;
    monthlyIncome?: number;
    dateOfBirth?: Date;
    notes?: string;
    isActive: boolean;
    createdAt: Date;
    updatedAt: Date;
    rentPayments: RentPayment[];
}